import axiosClient from './AxiosClient';
import {
  ReservationTypeResponseDto,
  ReservationTypeControllerFindReservationRequest,
} from './generated/openapi';

export type ReservationTypes = ReservationTypeResponseDto[];

const ReservationTypeService = {
  get(params: ReservationTypeControllerFindReservationRequest): Promise<ReservationTypes> {
    return axiosClient
      .get<ReservationTypes>(`/reservation_type/${params.postId}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to fetch data: ${error}`);
      });
  },
};

export default ReservationTypeService;
